module.exports = __webpack_public_path__ + "images/assets/e999b681e7aab9d5c060c6d99f765089.svg";